@if (isEditMode) {
  <div class="table-content" title="{{cellValue}}">
    <img [src]="cellValue" class="img-section">
  </div>
}

@if (!isEditMode) {
  <div class="table-content" title="{{cellValue}}">
    <img [src]="cellValue" class="img-section">
  </div>
}